import { useState } from 'react';
import { useAuthStore } from '../stores/useAuthStore';
import { useAuthGuard } from '../hooks/auth/useAuthGuard';
import { useOnboardingGuard } from '../hooks/auth/useOnboardingGuard';
import { useCurrentScreen } from '../hooks/screen/useCurrentScreen';
import CustomButtonSelector from '../components/CustomButtonSelector';

const SelecionarPerfil = () => {

  const [profiles, setProfiles] = useState([]);

  const perfisDisponiveis = useAuthStore(state => state.perfisDisponiveis);

  const setPerfisSelecionados = useAuthStore(state => state.setPerfisSelecionados);

  useCurrentScreen('Selecione os perfis de monitoramento');
  const { hasUser } = useAuthGuard();
  const { canRender } = useOnboardingGuard('profile');

  if (!hasUser || !canRender) return null;
  
  return (
    <CustomButtonSelector
      title="Perfis de monitoramento"
      options={perfisDisponiveis.map((p) => ({ id: p.id, label: p.nome }))}
      selected={profiles}
      setSelected={setProfiles}
      onConfirm={() => setPerfisSelecionados(profiles)}
      multiple={true}
    />
  );
};

export default SelecionarPerfil;